const HttpConstants = {
    METHODS: {
        GET: 'GET',
        POST: 'POST',
        PUT: 'PUT',
        DELETE: 'DELETE',
        PATCH: 'PATCH'
    },
    MIME_TYPES: {
        JSON: 'application/json',
        JSON_LD: 'application/ld+json',
        TEXT_CSV: 'text/csv',
        URL_ENCODED: 'application/x-www-form-urlencoded'
    },
    URL_SCHEME: {
        HTTP: 'http',
        HTTPS: 'https'
    }
};

export default HttpConstants;